import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arrayToString',
})
export class ArrayToStringPipe implements PipeTransform {
  public transform(
    input: Array<{ date: Date; level: string; value: unknown; stack: string | undefined }>,
    sep = '\n\n',
  ): string {
    let result = '';
    for (const obj of input) {
      result += obj.value
        ? obj.date.toLocaleTimeString() +
          ' ' +
          obj.level +
          ' ' +
          JSON.stringify(obj.value) +
          ' ' +
          (obj.stack || '') +
          sep
        : '';
    }
    return result;
  }
}
